module.exports = __webpack_public_path__ + "img/guardians-of-cloudia.1c310e5.png";